import React from "react";
import { Box, Typography } from "@mui/material";

const StatCard = ({ title, count, color }) => {
  return (
    <Box
      sx={{
        flex: 1,
        bgcolor: "white",
        p: 3,
        borderRadius: "12px",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
        minWidth: "250px",
      }}
    >
      <Typography variant="body1">{title}</Typography>
      <Typography variant="h5" fontWeight="bold" color={color || "black"}>
        {count}
      </Typography>
    </Box>
  );
};

export default StatCard;
